<div class="splash flex items-center justify-center bg-[#fff] dark:bg-[#000]">
  <div class="flex flex-col items-center gap-y-5">
    <!-- Logo mark -->
    <div class="flex items-center gap-x-2 animated pulse infinite">
      <img class="inline-block size-12 rounded-sm dark:hidden" src="/assets/images/logo_dark.png" alt="Kreador">
      <img class="hidden size-12 rounded-sm dark:inline-block" src="/assets/images/logo.png" alt="Kreador">
      <span class="relative font-bold text-3xl text-gray-900 dark:text-white tracking-tight" style="top:2px">
        Kreador <span class="text-purple-500 dark:text-neutral-500 font-normal">Suite</span>
      </span>
    </div>
    <!-- Progress bar -->
    <div class="w-48 h-0.5 bg-gray-100 dark:bg-neutral-900 rounded-full overflow-hidden">
      <div class="h-full bg-indigo-600 dark:bg-indigo-500 rounded-full loader-bar"></div>
    </div>
  </div>
</div>
